import { FormattedNumber } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import { GroupByDropdown } from './group-by-dropdown';
import { OrdersSidebarSectionHeaderChip } from '../orders-sidebar-section-header-chip';
import { messages } from './messages';
import sectionStyle from '../orders-sidebar-section.module.less';
import style from './items-section-header-content.module.less';

/**
 * @typedef {import('../../../../prop-types/intl').MessageDescriptorPropType} MessageDescriptor
 */

/**
 * @typedef {import('./items-section-types.d.ts').GroupByOption} GroupByOption
 */

/**
 * @param {object} props
 * @param {boolean} props.isSectionExpanded
 * @param {MessageDescriptor} props.sectionTitleMessageDescriptor
 * @param {(newOption: GroupByOption) => void} props.setUserSettingGroupItemsBy
 * @param {number} props.totalCount
 * @param {GroupByOption} props.userSettingGroupItemsBy
 * @returns {JSX.Element}
 */
export const ItemsSectionHeaderContent = ({
  isSectionExpanded,
  sectionTitleMessageDescriptor,
  setUserSettingGroupItemsBy,
  totalCount,
  userSettingGroupItemsBy,
}) => {
  return (
    <div className={style['items-section-header-content']}>
      <div className={sectionStyle['orders-sidebar-section-header-title-and-count']}>
        <Text textType={TextType.H4} value={sectionTitleMessageDescriptor} />
        <OrdersSidebarSectionHeaderChip>
          <FormattedNumber value={totalCount} />
        </OrdersSidebarSectionHeaderChip>
      </div>
      {isSectionExpanded ? (
        <div className={style['group-by-field']}>
          <Text textType={TextType.Caption} value={messages.groupByLabel} />
          <GroupByDropdown
            dropdownTogglerClassName={style['group-by-dropdown']}
            onOptionSelected={setUserSettingGroupItemsBy}
            selectedOption={userSettingGroupItemsBy}
          />
        </div>
      ) : null}
    </div>
  );
};
